<div *ngIf="rightsMap.read_access_prevented_log !== false && rightsMap.delete_access_prevented_log !== false; else noAccess" class="body">

    <div class="super-filter-container">
        <mat-form-field class="super-filter">
            <mat-label>Datensätze filtern</mat-label>
            <input matInput placeholder="z.B. nach GUID, Datum oder Nutzername"
                (keyup)="applyFilter($event.target.value)" />
        </mat-form-field>
        <mat-icon class="refresh-button" (click)="refresh()">refresh</mat-icon>
    </div>

    <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" class="log-table">

            <ng-container matColumnDef="options">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <div class="control-wrapper">
                        <mat-icon class="remover" (click)="removeDataset(row)" matTooltip="Einträg löschen">delete_forever</mat-icon>
                        <mat-icon class="solver" (click)="solveIssue(row)" matTooltip="Problem lösen">build</mat-icon>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="logid">
                <th mat-header-cell *matHeaderCellDef>GUID</th>
                <td mat-cell *matCellDef="let row">{{row.logid}}</td>
            </ng-container>

            <ng-container matColumnDef="logtime">
                <th mat-header-cell *matHeaderCellDef>Datum</th>
                <td mat-cell *matCellDef="let row">{{row.logtime | date:'dd.MM.yyyy HH:mm:ss'}}</td>
            </ng-container>

            <ng-container matColumnDef="logusername">
                <th mat-header-cell *matHeaderCellDef>Nutzername</th>
                <td mat-cell *matCellDef="let row">{{row.logusername}}</td>
            </ng-container>

            <ng-container matColumnDef="logcomponent">
                <th mat-header-cell *matHeaderCellDef>Komponente</th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let r of splitByComma(row.logcomponent)">
                        {{r}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="logrules">
                <th mat-header-cell *matHeaderCellDef>Erforderliche Regeln</th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let r of splitByComma(row.logrules)">
                        {{r}}
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [length]=length [pageSize]="pageSize" (page)="updatePageIndex($event)"></mat-paginator>

</div>

<ng-template #noAccess>
    <app-deny-access source="'access-denied-log.component'" [requirements]="Object.keys(rightsMap)"></app-deny-access>
</ng-template>
